// services/StudentService.ts
import { Student } from "../types/StudentModel";
import { createBaseRepositoryService } from "./baseRepositoryService";
import api from "./api";

const studentService = createBaseRepositoryService<Student>("/students");

// Custom function to register a new student
export const registerStudent = async (
  registrationData: Partial<Student>
): Promise<Student> => {
  try {
    const response = await api.post("/students/register", registrationData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error registering student:", error);
    throw error;
  }
};

export const getStudents = async () => {
  try {
    const response = await api.get("/students");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch students", error);
    throw error;
  }
};

// Fetch a single student by ID
export const getStudent = async (id: string) => {
  try {
    const response = await api.get(`/students/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch student", error);
    throw error;
  }
};

export const updateMyProfile = async (data: {
  photoUrl?: string;
  city?: string;
  country?: string;
  currentLocation?: string;
}) => {
  const response = await api.put("/students/me", data);
  return response.data;
};

export const getUnenrolledStudents = async (programName: string) => {
  try {
    const response = await api.get(`/students/unenrolled/${programName}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch unenrolled students", error);
    throw error;
  }
};

export const getCourseProgress = async () => {
  try {
    const response = await api.get(`/students/course-progress`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch course progress", error);
    throw error;
  }
};

export default studentService;
